// Per-route SEO. Drop <Seo .../> at the top of a page to set its title,
// description, canonical URL, and social tags. Overrides the static defaults
// in public/index.html for that route (react-helmet-async swaps the head tags
// as you navigate).

import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://tudusmartplanner.com';

function Seo({ title, description, path = '/', image = '/logo512.png', noindex = false }) {
  const url = `${SITE}${path}`;
  const img = image.startsWith('http') ? image : `${SITE}${image}`;
  const fullTitle = title || 'Tudu — Smart Task Planner, Routines & Shopping Deals';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}

      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}

export default Seo;
